import React, { useState } from 'react'
import { Grid, Divider, Item, Button } from "semantic-ui-react"
import TooltipGridRow from "./TooltipGridRow"
import { displayField, displayCurrency } from '../../../utils/utils'

export function RefundField({orderId, refund, handleRefund, invoiceUsed, allowSendText}) {
  const [toBeRefunded, setToBeRefunded] = useState((Number(refund || 0)).toFixed(2))
  const [editing, setEdit] = useState(false)
  const [sendText, setSendText] = useState(false)

  return (
    <Item>
      {editing &&
        <span>
          <input value={toBeRefunded} onChange={(e) => setToBeRefunded(e.target.value)} /> &nbsp;
          <Button
            compact
            positive
            onClick={() => handleRefund(
              { id: orderId, amount: toBeRefunded, invoiceRefund: invoiceUsed, sendText: sendText },
              () => setEdit(false)
            )}
          >
            Send Refund
          </Button>
          <Button compact negative onClick={() => setEdit(false)}>
            Cancel
          </Button>

          {allowSendText &&
            <React.Fragment>
              <input
                type="checkbox"
                onChange={() => setSendText(!sendText)}
                checked={sendText}
                className='cursor-pointer'
                style={{marginLeft: '15px', marginBottom: '10px'}}
              />
              <small
                onClick={() => setSendText(!sendText)}
                className='cursor-pointer'
                style={{paddingLeft: '5px'}}
              >
                Send customer text
              </small>
            </React.Fragment>
          }
        </span>
      }
      {!editing &&
        <span>
          ${displayField(toBeRefunded)} &nbsp;
          <Button compact positive onClick={() => setEdit(true)}>
            Issue Refund
          </Button>
        </span>
      }
    </Item>
  )
}

function GiveRefund({orderId, refund, handleRefund}) {
  return (
    <Grid.Row key={`tooltip-grid-row`} style={{paddingTop: 0, paddingBottom: 0}}>
      <Grid.Column width={6}>
        <Item>
          <strong>Recommended Refund:</strong>
        </Item>
      </Grid.Column>
      <Grid.Column width={10}>
        <RefundField orderId={orderId} refund={refund} handleRefund={handleRefund} invoiceUsed={true} />
      </Grid.Column>
    </Grid.Row>
  )
}

function ResolveField({order, handleResolution}) {
  if (order.invoice_reconciliation.resolved) {
    return <Button disabled positive>Resolved</Button>
  }
  else {
    return (
      <Button warning onClick={handleResolution}>
        Resolve
      </Button>
    )
  }
}

export default function InvoiceTab({order, handleRefund, handleResolution}) {
  if (!order.invoice_reconciliation) {
    return (
      <div>
        <em>
          No invoice on record. Perhaps the national hasn't sent us the invoice yet, or this national has no invoice integration.
        </em>
      </div>
    )
  }

  const {
    over_retail, tax_inconsistency, customer_braintree_inconsistency, ai_invoice_inconsistency,
    recommended_refund_amount, refunded, ai_amount_pre_tax, customer_amount_pre_tax,
    customer_order_service_amount_pre_tax, invoice_amount_pre_tax, ai_tax, customer_tax, invoice_tax,
    braintree_amount, refunded_amount
  } = order.invoice_reconciliation

  const topLineInvoiceData = [
    { label: "Over Retail:", attr: over_retail ? 'YES' : 'NO' },
    { label: "Refunded Overage:", attr: refunded ? 'YES' : 'NO' },
    { label: "Tax Rate Different:", attr: tax_inconsistency ? 'YES' : 'NO' },
    { label: "Customer's Price and Braintree Price Different:", attr: customer_braintree_inconsistency ? 'YES' : 'NO' },
    { label: "AI and Invoice Price Different:", attr: ai_invoice_inconsistency ? 'YES' : 'NO' }
  ]

  const pretaxData = [
    { label: "AI Pre-Tax Amount:", attr: ai_amount_pre_tax && displayCurrency(ai_amount_pre_tax) },
    { label: "Just Order Services Pre-Tax Amount:", attr: customer_order_service_amount_pre_tax && displayCurrency(customer_order_service_amount_pre_tax) },
    { label: "Customer Pre-Tax Amount (After Promos/Discount):", attr: customer_amount_pre_tax && displayCurrency(customer_amount_pre_tax) },
    { label: "Invoice Amount Pre-Tax:", attr: invoice_amount_pre_tax && displayCurrency(invoice_amount_pre_tax) }
  ]

  const taxData = [
    { label: "AI Tax:", attr: ai_tax && `$${ai_tax} (${parseInt(ai_tax*100/customer_order_service_amount_pre_tax)}%)` },
    { label: "Customer's Tax:", attr: customer_tax && `$${customer_tax} (${parseInt(customer_tax*100/customer_amount_pre_tax)}%)` },
    { label: "Invoice Tax:", attr: invoice_tax && `$${invoice_tax} (${parseInt(invoice_tax*100/invoice_amount_pre_tax)}%)` },
  ]

  const summary = [
    { label: "Total Braintree Charges:", attr: braintree_amount && `${displayCurrency(braintree_amount)}` },
    { label: "Total Refunded:", attr: refunded_amount && `${displayCurrency(refunded_amount)}` }
  ]

  return (
    <Grid style={{ paddingTop: "15px", paddingBottom: "15px" }}>
      <Grid.Row style={{justifyContent: "center"}}>
        <ResolveField order={order} handleResolution={handleResolution} />
      </Grid.Row>
      <Divider />
      <TooltipGridRow
        data={topLineInvoiceData}
        labelWidth={6}
        attrWidth={6}
      />
      <Divider />
      <TooltipGridRow
        data={pretaxData}
        labelWidth={10}
        attrWidth={6}
      />
      <Divider />
      <TooltipGridRow
        data={taxData}
        labelWidth={6}
        attrWidth={6}
      />
      <Divider />
      <TooltipGridRow
        data={summary}
        labelWidth={6}
        attrWidth={6}
      />
      {recommended_refund_amount && !refunded &&
        <GiveRefund
          orderId={order.id}
          refund={recommended_refund_amount}
          handleRefund={handleRefund}
        />
      }
    </Grid>
  )
}